import React, { useState } from 'react'

import Icon from './Icon'

const AccordionItem = React.memo(({ domanda, risposta }) => {
  const [opened, setOpened] = useState(false)

  return (
    <div className={`accordion-item ${opened ? 'accordion-item--opened' : ''}`}>
      <div
        className="accordion-item__line"
        onClick={() => {
          setOpened(!opened)
        }}
      >
        <h3 className="accordion-item__title">{domanda}</h3>
        <span className="accordion-item__icon">
          <Icon id="chevron-down" />
        </span>
      </div>
      <div className="accordion-item__inner">
        <div className="accordion-item__content">
          <div
            className="accordion-item__paragraph"
            dangerouslySetInnerHTML={{ __html: risposta }}
          />
        </div>
      </div>
    </div>
  )
})

export default AccordionItem
